import { render } from "./CrudArtEngenheiroTransportador.vue?vue&type=template&id=2537b9e0&scoped=true"
import script from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"
export * from "./CrudArtEngenheiroTransportador.vue?vue&type=script&lang=ts"

import "./CrudArtEngenheiroTransportador.vue?vue&type=style&index=0&id=2537b9e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2537b9e0"

export default script